module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    staticClass: "main-container",
    attrs: {
      "container": false
    }
  }, [(_vm.loading) ? _c('Loader') : (_vm.error) ? _c('Basic404', [_c('p', {
    staticClass: "fs-8"
  }, [_vm._v("Video not found ")]), _vm._v(" "), _c('p', {
    staticClass: "fs-6"
  }, [_vm._v("Do you have access?")])]) : _c('VideoBase', {
    attrs: {
      "video": _vm.video
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-369d330a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoByID.vue
// module id = 1005
// module chunks = 0